// https://github.com/rt2zz/redux-persist/issues/1208#issuecomment-658695446
import createWebStorage from 'redux-persist/lib/storage/createWebStorage';

/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
const createNoopStorage = () => {
  return {
    getItem(_key) {
      return Promise.resolve(null);
    },
    setItem(_key, value) {
      return Promise.resolve(value);
    },
    removeItem(_key) {
      return Promise.resolve();
    },
  };
};
/* eslint-enable arrow-body-style */
/* eslint-enable no-unused-vars */

const storage = typeof window === 'undefined' ? createNoopStorage() : createWebStorage();

export default storage;
